import ZoomMediasPanel from '@ui/ZoomMediasPanel/component'
import * as coreCommon from 'assets/core/js/common'
import ElementPropertiesManager from 'assets/core/js/module/element-properties-manager'

const init = (element: HTMLElement): void => {
  let elementWithAttributes: HTMLElement | null = element

  if (!element.hasAttribute('[data-zoom-id]')) {
    elementWithAttributes = element.closest<HTMLElement>('[data-zoom-id]')
  }

  if (!elementWithAttributes) {
    return
  }

  const id = elementWithAttributes.getAttribute('data-zoom-id')

  if (!id) {
    return
  }

  const zoomMediasPanelEl = document.getElementById(id)
  let zoomMediasPanel: ZoomMediasPanel | undefined = zoomMediasPanelEl
    ? ElementPropertiesManager.getProperty(zoomMediasPanelEl, 'zoomMediasPanel')
    : undefined

  if (!zoomMediasPanel) {
    const templateEl = document.getElementById(`${id}-template`) as HTMLElement

    if (!templateEl) {
      return
    }

    templateEl.parentNode?.insertBefore<HTMLElement>(coreCommon.createNodeFromHTML(templateEl.innerHTML), templateEl)
    templateEl.remove()

    zoomMediasPanel = new ZoomMediasPanel(id, {
      onInit: (zoom: ZoomMediasPanel) => {
        zoom.open()
      },
      onContentSet: function (zoom: ZoomMediasPanel) {
        if (element.hasAttribute('data-index')) {
          zoom?.goToMedia(element.getAttribute('data-index') as string)
        }
      },
    })
  } else {
    if (element.hasAttribute('data-index')) {
      zoomMediasPanel?.goToMedia(element.getAttribute('data-index') as string)
    } else {
      zoomMediasPanel?.open()
    }
  }
}

export default (): void => {
  document.body.addEventListener('close-all-modals', () => {
    document.querySelectorAll<HTMLElement>('.zoom-medias-panel').forEach((el) => {
      ElementPropertiesManager.getProperty<ZoomMediasPanel>(el, 'zoomMediasPanel')?.close()
    })
  })
}

export const initZoomMediasPanel = (element: HTMLElement, setClickListener = false): void => {
  if (!element) {
    return
  }

  if (setClickListener) {
    element.addEventListener('click', () => {
      init(element)
    })

    return
  }

  init(element)
}
